import { TableRow } from "../components/MyTable";
import { TableHeadRows } from "../components/MyTable/TableHead";

import * as XLSX from "xlsx-js-style"
import * as FileSaver from 'file-saver';

export interface DownloadData {
    tableHeadRows: TableHeadRows[],
    tableBodyRows: TableRow<string, any>,
    fileName?: string,
    sheetName?: string,
}

export const generateExcel = ({
    tableHeadRows, 
    tableBodyRows,
    fileName = 'user-document',
    sheetName = 'Sheet1',
}: DownloadData) => {

    const filteredHeadRows = tableHeadRows.filter(r => r.label !== "")
    let wscols: any = [];
    const rowsHeadArray: any[] = [filteredHeadRows.map((head, ii: number) => {
        const label = head.label;
        wscols.push({wch: label.length})
        return ({
            v: label, t: "s", s: { fill: { fgColor: { rgb: "63AFC8" } },}
        })
    })];
    tableBodyRows.forEach((row: any, i: number) => (
        rowsHeadArray.push(filteredHeadRows.map((hKey, ii: number) => {
            const label = row[ii].value;
            if ((label.length + 2) > wscols[ii].wch) {
                wscols[ii].wch = (label.length + 2);
            }
            return ({v: label, t: "s"});
        }))
    ));
    let ws = XLSX.utils.aoa_to_sheet(rowsHeadArray);
    ws['!cols'] = wscols;
    const wb = {
        Sheets: {
        [sheetName]: ws,
        },
        SheetNames: [sheetName],
    };
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(file, fileName + fileExtension);
}